module.exports = __webpack_public_path__ + "static/loop-9500b8fc23bb7532e12231a4b39aef29.mp4";